export const notificationIsRead = [
  { key: "true", badgeColor: "badge-soft-success" },
  { key: "false", badgeColor: "badge-soft-warning" },
];

export const notificationModeList = {
  VIEW_NOTIFICATION_DETAIL: "VIEW_NOTIFICATION_DETAIL",
};